import styled from "styled-components";

const ConversationBody = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-bottom: 20px;
`

export default ConversationBody